export enum PromoContentAlignment {
  LEFT = 'left',
  CENTER = 'center',
  RIGHT = 'right'
}
